import { Channels } from 'generated-graphql/types';
import { CampaignStatus } from 'services/campaign/types';

export const STOPPABLE_CAMPAIGN_STATUSES: CampaignStatus[] = [
  CampaignStatus.LIVE,
  CampaignStatus.SCHEDULED,
  CampaignStatus.SENDING_MESSAGES,
  CampaignStatus.FINISHED_GENERATING,
  CampaignStatus.FINISHED_SENDING,
  CampaignStatus.PAUSED
];

export const textChannelByChannelValue = {
  [Channels.Whatsapp]: 'WhatsApp',
  [Channels.Sms]: 'SMS',
  [Channels.Email]: 'Email',
  [Channels.WebChat]: 'Web Chat',
  [Channels.WebChatViaEmail]: 'Web Chat via Email'
};

export const CAMPAIGN_CREATION_PARAMS = {
  automation: 'automation'
};
